import { useTranslation } from 'react-i18next'
import React from 'react'

import { Text, Title } from '../../../components/presentation/Text'
import Icon from '../../../components/shapes/Icon'
import Separator from '../../../components/helpers/Separator'

const SuccessMessage = () => {
  const { t } = useTranslation('session')
  return (
    <div>
      <Icon name="BsFillFlagFill" />
      <Separator weight={4} />
      <Title size="h3">{t('forgotPasswordForm.requestCompleted')}</Title>
      <Text>{t('forgotPasswordForm.emailBeingSent')}</Text>
    </div>
  )
}

export default SuccessMessage
